module.exports = __webpack_public_path__ + "static/media/whatsapp-topo.af3b0709.svg";